import morphdom from "morphdom";

class PdpVariantButton extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.linkEl = this.closest("[data-variant-link]");

    if (!this.linkEl) return;

    this.handleLinkClick = (e) => {
      e.preventDefault();
      this.selectVariant();
    };

    this.linkEl.addEventListener("click", this.handleLinkClick);
  }

  disconnectedCallback() {
    this.linkEl?.removeEventListener("click", this.handleLinkClick);
  }

  selectVariant() {
    const url = new URL(
      this.getAttribute("product-url"),
      window.location.origin,
    );
    const targetSelector = "#MainContent";

    fetch(url)
      .then((res) => res.text())
      .then((text) => {
        const section = new DOMParser().parseFromString(text, "text/html");

        const targetEl = document
          .createRange()
          .createContextualFragment(
            section.querySelector(targetSelector).outerHTML,
          );

        if (!window.Shopify.designMode && this.updateUrl) {
          url.searchParams.delete("section_id");
          window.history.pushState("", "", url);
        }

        const updateElAttributes = (fromEl, toEl) => {
          fromEl.dataset.attributesOnly.split(",").forEach((attribute) => {
            // skip blanks
            if (!attribute) return;

            fromEl.setAttribute(attribute, toEl.getAttribute(attribute));
          });
        };

        morphdom(this.closest(targetSelector), targetEl, {
          onBeforeElUpdated: (fromEl, toEl) => {
            if (
              "partialMorph" in fromEl.dataset ||
              "partialMorph" in toEl.dataset
            ) {
              fromEl.querySelectorAll("[data-update]").forEach((updateEl) => {
                updateEl.innerHTML = toEl.querySelector(
                  `[data-update="${updateEl.dataset.update}"]`,
                ).innerHTML;
              });

              fromEl
                .querySelectorAll("[data-attributes-only]")
                .forEach((attributesEl) => {
                  const toAttributesEl = toEl.querySelector(
                    `#${attributesEl.id}`,
                  );

                  if (!toAttributesEl) return;

                  updateElAttributes(attributesEl, toAttributesEl);
                });

              return false;
            }

            if (
              "forceUpdate" in fromEl.dataset ||
              "forceUpdate" in toEl.dataset
            ) {
              fromEl.replaceWith(toEl);
              return false;
            }

            if ("attributesOnly" in fromEl.dataset) {
              updateElAttributes(fromEl, toEl);

              return false;
            }
          },
        });
      });
  }

  get updateUrl() {
    return !this.hasAttribute("disable-update-url");
  }
}

if (!customElements.get("pdp-variant-button")) {
  customElements.define("pdp-variant-button", PdpVariantButton);
}
